import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../../services/auth.service'


const PrivateRoute = ({component: Component,user, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        
        <Route {...rest} render={props => (
            AuthService.getCurrentUser() ? <Component {...props} /> : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;